import CustomizeSidebar from './CustomizeSidebar.container';

export default CustomizeSidebar;
